import { stdObject } from "../data/types/stdObject";
import { sendData } from "./sendData";

export const updateNewRate = async (payload: stdObject, logoutAction: any) => {
  await sendData({
    endPoint: "updatePriceRate",
    payload,
    logoutAction,
  });
};
